module.exports = __webpack_public_path__ + "static/img/wt@3x.05c03e86.png";